import { Component, OnInit } from "@angular/core";
import { KeycloakProfile } from "keycloak-js";
import { AuthService } from "../../services/auth/auth.service";
import { Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-dropdown-user",
  templateUrl: "./dropdown-user.component.html",
  styleUrl: "./dropdown-user.component.scss",
})
export class DropdownUserComponent implements OnInit {
  isDropdownOpen!: boolean;
  //
  isRTL: boolean = false;
  private langSub!: Subscription;

  profile!: KeycloakProfile | null;

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.loadProfile();
    //
    this.checkDirection();
  }

  async loadProfile() {
    this.profile = await this.authService.getProfile();
  }

  signout() {
    this.authService.logout();
  }

  //
  private checkDirection() {
    this.isRTL = document.documentElement.getAttribute("dir") === "rtl";
  }
}
